export enum Vertical {
  HOMES = 1
}
